import { FINDING_PROPOSED_STATUS, OPTIONAL_STATUS } from "./status";

export const MAX_ACCEPT_RISK_COUNT = 3;

export const PROPOSE_MITIGATED_SUPPORTED_TOOLS = [
  "HackerOne",
  "Cobalt",
  "JIRA",
  "ArmorCode Code Insights",
];

export const MANUAL_FINDING_MARK_DOWN_FIELDS = [
  "description",
  "impact",
  "mitigation",
  "stepsToReproduce",
];

export const ATTACHMENT_LINK_PREFIX = "!attachment!";

export const TOOLS_WITHOUT_ATTACHMENT_SUPPORT = [
  "GITHUB_ISSUES",
  "PAGERDUTY",
  "ARCHER",
];

export const ATTACHMENT_TOOLS = [
  "HackerOne",
  "Fortify",
  "Bugcrowd",
  "Edgescan",
  "Cobalt",
];

export const DEVELOPER_EMAIL_SUFFIX = "armorcode.io";

export const ARMORCODE_PRIMARY_CORRELATED_FINDING =
  "armorcode.primary_correlated_finding";

const KEY_TEXT = { ...OPTIONAL_STATUS, ...FINDING_PROPOSED_STATUS };

export const BULK_FINDING_ACTION_KEYS = KEY_TEXT;

export const BULK_FINDING_ACTION_MAP: Record<string, string> = {
  [KEY_TEXT.CREATE_TICKETS]: "CREATE_TICKETS",
  [KEY_TEXT.FALSE_POSITIVE]: "MARK_FALSE_POSITIVE",
  [KEY_TEXT.ACCEPT_RISK]: "MARK_ACCEPT_RISK",
  [KEY_TEXT.CORRELATE_FINDINGS]: "UPDATE_FINDINGS",
  [KEY_TEXT.EDIT_BASIC_DETAILS]: "FINDINGS_UPDATE_BASIC_DETAILS",
  [KEY_TEXT.BULK_EDIT_DETAILS]: "FINDINGS_UPDATE_BASIC_DETAILS",
  [KEY_TEXT.CHANGE_PROJECTS]: "UPDATE_FINDINGS_PROJECT",
  [KEY_TEXT.CONFIRMED]: "MARK_CONFIRM",
  [KEY_TEXT.MITIGATED]: "MARK_MITIGATED",
  [KEY_TEXT.OPEN]: "MARK_REOPEN",
  [KEY_TEXT.SUPPRESSED]: "MARK_SUPPRESSED",
  [KEY_TEXT.TRIAGE]: "MARK_TRIAGE",
  [KEY_TEXT.IN_PROGRESS]: "MARK_IN_PROGRESS",
  [KEY_TEXT.CONTROLLED]: "MARK_CONTROLLED",
  [KEY_TEXT.CHANGE_CATEGORY]: "UPDATE_CATEGORY",
  [KEY_TEXT.CHANGE_SEVERITY]: "UPDATE_SEVERITY",
  [KEY_TEXT.CHANGE_DUE_DATE]: "FINDINGS_CHANGE_DUE_DATE",
  [KEY_TEXT.CHANGE_OWNER]: "ASSIGN_OWNER",
  [KEY_TEXT.DETACH_TICKET]: "DELETE_TICKETS",
  [KEY_TEXT.PROPOSE_FALSE_POSITIVE]: "PROPOSE",
  [KEY_TEXT.PROPOSE_CATEGORY]: "PROPOSE",
  [KEY_TEXT.PROPOSE_SEVERITY]: "PROPOSE",
  [KEY_TEXT.PROPOSE_ACCEPTRISK]: "PROPOSE",
  [KEY_TEXT.PROPOSE_SUPPRESSED]: "PROPOSE",
  [KEY_TEXT.PROPOSE_MITIGATED]: "PROPOSE",
  [KEY_TEXT.PROPOSE_ASSIGNEE]: "PROPOSE",
  [KEY_TEXT.PROPOSE_DUE_DATE]: "PROPOSE",
  [KEY_TEXT.PROPOSE_BASIC_CHANGE]: "PROPOSE",
  [KEY_TEXT.PROPOSE_TRIAGE]: "PROPOSE",
  [KEY_TEXT.PROPOSE_IN_PROGRESS]: "PROPOSE",
  [KEY_TEXT.PROPOSE_CONTROLLED]: "PROPOSE",
  [KEY_TEXT.PROPOSE_CUSTOM_FIELDS]: "PROPOSE",
};
